<div class="event-drop">
    <div class="heading">
        <span class="title">UPCOMING EVENTS</span>
        <div class="pull-right">
            <div class="btn-group mb-sm">
                <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">
                    <img src="assets/img/filter.svg" alt="">All
                    <!-- <span class="caret"></span> -->
                </a>
                <ul role="menu" class="dropdown-menu animated fadeIn right">
                    <li><a href="#">All</a>
                    </li>
                    <li><a href="#">Going</a>
                    </li>
                    <li><a href="#">Interested</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="event-drop-inner">
        <div class="event-drop-box">
            <div class="event-drop-box-top">
                <div class="date">
                    <span>09</span>
                    JAN '18
                </div>
                <div class="right-block">
                    <div class="inner-title">Trainer’s Annual Marathon Meet</div>
                    <div class="sub-title">Windsor Track, WING A</div>
                </div>
            </div>
            <div class="event-drop-box-bottom">
                <div class="btn-group">
                    <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">Interested
                        <!-- <span class="caret"></span> -->
                    </a>
                    <ul role="menu" class="dropdown-menu animated fadeIn">
                        <li><a href="#">All</a>
                        </li>
                        <li><a href="#">Going</a>
                        </li>
                        <li><a href="#">Interested</a>
                        </li>
                    </ul>
                </div>
                <div class="right-text-int">107 Interested </div>
            </div>
        </div>
        <div class="event-drop-box">
            <div class="event-drop-box-top white">
                <img src="assets/img/event-bg-1.jpg" alt="Image">
                <div class="date">
                    <span>09</span>
                    JAN '18
                </div>
                <div class="right-block">
                    <div class="inner-title">Trainer’s Annual Marathon Meet</div>
                    <div class="sub-title">Windsor Track, WING A</div>
                </div>
            </div>
            <div class="event-drop-box-bottom">
                <div class="btn-group">
                    <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">Going
                        <!-- <span class="caret"></span> -->
                    </a>
                    <ul role="menu" class="dropdown-menu animated fadeIn">
                        <li><a href="#">All</a>
                        </li>
                        <li><a href="#">Going</a>
                        </li>
                        <li><a href="#">Interested</a>
                        </li>
                    </ul>
                </div>
                <div class="right-text-int">107 Interested </div>
            </div>
        </div>
    </div>
    <div class="side-overlay box-overlay">
        <div class="inn-text">
            Drag and<br>
            Drop
        </div>
    </div>
</div>